import React, { useState } from 'react';

interface PromoItem {
    typeCategory: 'promotions';
    id: string;
    enabled: boolean;
    name: string;
    icon?: string;
    position: number;
    required?: boolean;
}

interface EditPromoFormProps {
    option: PromoItem;
    onSave: (updatedOption: PromoItem) => void;
    onClose: () => void;
}

export default function EditPromoForm({ option, onSave, onClose }: EditPromoFormProps) {
    const [formData, setFormData] = useState<PromoItem>({
        ...option,
        typeCategory: 'promotions',
    });
    const [imageBase64, setImageBase64] = useState<string | null>(null);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value, type, checked } = e.target as HTMLInputElement;
        if (name === 'position') {
            // Permitir dígitos, longitud máxima de 2, evitar el número 0 como valor final
            if (/^\d{0,2}$/.test(value)) {
                setFormData({
                    ...formData,
                    position: value === '' ? null as unknown as number : Number(value),
                });
            }
            return;
        }
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value,
            // icon: imageBase64, 
        });
    };

    const handleSavePromotion = () => {
        console.log("Datos de la góndola en el modal antes de enviarse:", formData);
        if (imageBase64 === null) {
            delete formData.icon;
        }
        formData.position = Number(formData.position);

        onSave(formData);
        onClose();
    };

    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result as string;
                setImageBase64(base64String);
                if (base64String) {
                    setFormData({
                        ...formData,
                        icon: base64String,
                    });

                }
            };
            reader.readAsDataURL(file);
        }
    };

    return (
        <div className="modal">
            <div className="modal-content">
                <h2 className="text-xl text-white font-semibold mb-5 w-full border-b-2 p-5 bg-primary rounded-t-lg">
                    Configuración de Promoción: {formData.name}
                </h2>
                <form className="p-5">
                    <div className='flex flex-row justify-between mb-5'>
                        <div className="flex flex-col">
                            <label>Nombre:</label>
                            <input
                                className="inputFormCat"
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                            />
                        </div>
                        <div className='flex '>
                            <label>Inactiva</label>
                            <div
                                className={`toggle mx-4 ${formData.enabled ? 'enabled' : 'disabled'}`}
                                onClick={() =>
                                    setFormData({
                                        ...formData,
                                        enabled: !formData.enabled,
                                    })
                                }
                            >
                                <div className="toggle-circle"></div>
                            </div>
                            <label>Activa</label>
                        </div>
                    </div>

                    {/* Icono */}
                    <div className="mb-5 flex flex-col">
                        <label className='font-semibold'>Archivo de Imagen:</label>
                        {/* <input
                            className="inputFormCat"
                            type="text"
                            name="icon"
                            value={formData.icon}
                            onChange={handleChange}
                        /> */}
                        <input
                            type="file"
                            accept="image/png, image/jpeg"
                            onChange={handleImageChange}
                            className="w-full"
                        />
                    </div>

                    {/* Posición */}
                    <div className="mb-5 flex flex-col">
                        <label className='font-semibold'>Posición:</label>
                        <input
                            className="inputFormCat w-20"
                            type="number"
                            name="position"
                            value={formData.position}
                            onChange={handleChange}
                        />
                    </div>

                    {/* Estado (Activa/Inactiva) */}
                    {/* <div className="flex items-center mb-5">
                        <label>Estado:</label>
                        <div
                            className={`toggle mx-4 ${formData.enabled ? 'enabled' : 'disabled'}`}
                            onClick={() =>
                                setFormData({
                                    ...formData,
                                    enabled: !formData.enabled,
                                })
                            }
                        >
                            <div className="toggle-circle"></div>
                        </div>
                        <span>{formData.enabled ? 'Activa' : 'Inactiva'}</span>
                    </div> */}

                    {/* Botones de acción */}
                    <div className="modal-actions">
                        <button
                            type="button"
                            className="buttonGuardarModalSave"
                            onClick={handleSavePromotion}
                        >
                            Guardar
                        </button>
                        <button
                            type="button"
                            className="buttonGuardarModalCancel"
                            onClick={onClose}
                        >
                            Cancelar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}